import { render, staticRenderFns } from "./recruitment-view-card.vue?vue&type=template&id=015f6a02&scoped=true"
import script from "./recruitment-view-card.vue?vue&type=script&lang=js"
export * from "./recruitment-view-card.vue?vue&type=script&lang=js"
import style0 from "./recruitment-view-card.vue?vue&type=style&index=0&id=015f6a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f6a02",
  null
  
)

export default component.exports